import { render, staticRenderFns } from "./TextV1Properties.vue?vue&type=template&id=02c9ab2e&"
import script from "./TextV1Properties.vue?vue&type=script&lang=js&"
export * from "./TextV1Properties.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../Breeze.Kiosk.Frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports